import axios from "axios";
import { logout } from "./authService";

const API_BASE_URL = "";

let refreshPromise = null; // Uloží právě probíhající požadavek na obnovení tokenu

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Povolit odesílání cookies s požadavky
  headers: { "Content-Type": "application/json" }, // Nastavení hlavičky pro JSON
});

const refreshAccessToken = async () => {
  if (!refreshPromise) {
    refreshPromise = axiosInstance
      .post("/api/auth/refresh-token")
      .then(({ data }) => {
        localStorage.setItem("accessToken", data.accessToken);
        return data.accessToken;
      })
      .catch((error) => {
        console.error("Chyba při aktualizaci refresh tokenu:", error);

        if (error.response?.status === 401) {
          console.warn("Požadavek na refresh token selhal. Odhlašuji...");
          logout();
        }
      })
      .finally(() => {
        // Vyčištění proměnné po úspěchu nebo selhání
        refreshPromise = null;
      });
  }
  return refreshPromise;
};

// Interceptor pro každý odchozí požadavek
axiosInstance.interceptors.request.use(
  (config) => {
    // Získání access tokenu z localStorage
    let accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      config.headers["Authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor pro zpracování odpovědí
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Pokud selže samotný požadavek na refresh token, není třeba ho znovu pokoušet
    if (originalRequest.url.includes("/api/auth/refresh-token")) {
      return Promise.reject(error);
    }

    // Pokud je odpověď 401 (neoprávněný přístup) a požadavek ještě nebyl opakován
    if (
      error.response?.status === 401 &&
      localStorage.getItem("accessToken") &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshAccessToken();
        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return axiosInstance(originalRequest); // retry original request
      } catch (e) {
        return Promise.reject(e);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
